/**
 * 본문 태그 스타일.
 *
 * `@tailwindcss/typography` 를 쓰지 않는 이유: prose 클래스는 다크모드·코드블록·표를
 * 우리 토큰에 맞추려면 결국 전부 override 하게 되고, 그 override 가 어디에 걸렸는지
 * 추적이 안 된다. 태그 수가 열 몇 개라 직접 적는 편이 싸다.
 */
export const BODY_STYLE = {
  paragraph: 'my-3 text-[15px] leading-[1.85] text-neutral-700 dark:text-neutral-300',
  h2: 'group mt-10 mb-3 scroll-mt-6 text-[20.5px] font-extrabold tracking-tight text-neutral-900 dark:text-neutral-100',
  h3: 'mt-7 mb-2 scroll-mt-6 text-[16.5px] font-bold text-neutral-900 dark:text-neutral-100',
  ul: 'my-3 list-disc space-y-1.5 pl-5 text-[15px] leading-[1.8] text-neutral-700 dark:text-neutral-300',
  ol: 'my-3 list-decimal space-y-1.5 pl-5 text-[15px] leading-[1.8] text-neutral-700 dark:text-neutral-300',
  code: 'rounded border border-neutral-200 bg-neutral-100 px-1.5 py-px font-mono text-[13px] text-[#b23c17] dark:border-white/12 dark:bg-white/8 dark:text-[#f0a882]',
  pre: 'my-5 overflow-x-auto rounded-xl border border-neutral-200 bg-neutral-50 p-4 font-mono text-[13px] leading-6 text-neutral-800 dark:border-white/12 dark:bg-white/5 dark:text-neutral-200',
  blockquote:
    'my-5 border-l-2 border-neutral-200 pl-4 text-[15px] leading-7 text-neutral-500 dark:border-white/15 dark:text-neutral-400',
  hr: 'my-9 border-neutral-200 dark:border-white/12',
  link: 'font-semibold text-brand-600 underline-offset-2 hover:underline dark:text-brand-400',
  // 표는 본문 폭을 넘겨도 자기 안에서만 스크롤한다. 페이지가 가로로 밀리면 안 된다.
  tableWrap: 'my-5 overflow-x-auto',
  table: 'w-full border-collapse text-[14px]',
  th: 'border border-neutral-200 bg-neutral-50 px-3 py-2.5 text-left text-[12px] font-bold text-neutral-500 dark:border-white/12 dark:bg-white/5 dark:text-neutral-400',
  td: 'border border-neutral-100 px-3 py-2.5 align-top text-neutral-700 dark:border-white/8 dark:text-neutral-300',
  image: 'my-6 block h-auto max-w-full rounded-xl border border-neutral-200 dark:border-white/12',
} as const;
